export const missions = [
    {
      id: 1,
      missionName: 'Operation Suraksha',
      objective: 'Secure the border region',
      missionCode: 'SURAKSHA123',
      location: 'Jammu & Kashmir',
      date: '2024-01-01',
      time: '08:00',
      duration: '2 hours',
      teamMembers: 'Team Shakti',
      commander: 'Colonel Arjun Singh',
      specialists: 'Major Vikram Rathore',
      vehicles: 'Tata Safari',
      weapons: 'INSAS Rifle',
      communicationDevices: 'DRDO Communication Kit',
      medicalSupplies: 'First Aid Kit',
      specialEquipment: 'Night Vision Goggles',
      transportArrangements: 'Army Trucks',
      accommodation: 'Base Camp A',
      foodWaterSupply: 'Packaged Meals',
      threatAssessment: 'High Risk',
      terrainAnalysis: 'Mountainous Terrain',
      surveillanceData: 'Satellite Images',
      rulesOfEngagement: 'Rules for Border Protection',
      emergencyProcedures: 'Standard Operating Procedures',
      communicationProtocols: 'Secure Lines',
      riskAssessment: 'High Probability of Conflict',
      contingencyPlans: 'Evacuation Plan',
      permissionsClearances: 'State Government Clearances',
      ethicalGuidelines: 'Code of Conduct',
      debriefing: 'Mission Report',
      reporting: 'Daily Briefings',
      evaluation: 'Post-Mission Review',
      emergencyContacts: 'Local Police Station',
      supportTeams: 'Medical Team Bravo',
      documentation: 'Mission Dossier',
      environmentalConsiderations: 'Snow and Ice',
      status: 'ongoing' // Added status
    },
    {
      id: 2,
      missionName: 'Operation Vijay',
      objective: 'Neutralize insurgents',
      missionCode: 'VIJAY123',
      location: 'Manipur',
      date: '2024-02-15',
      time: '10:00',
      duration: '3 hours',
      teamMembers: 'Team Veer',
      commander: 'Brigadier Ravi Kumar',
      specialists: 'Captain Priya Mehta',
      vehicles: 'Mahindra Bolero',
      weapons: 'AK-47',
      communicationDevices: 'Satellite Phones',
      medicalSupplies: 'Advanced Trauma Kit',
      specialEquipment: 'Thermal Imager',
      transportArrangements: 'Helicopter Lift',
      accommodation: 'Field Hospital',
      foodWaterSupply: 'Local Supplies',
      threatAssessment: 'Moderate Risk',
      terrainAnalysis: 'Dense Forest',
      surveillanceData: 'Drone Footage',
      rulesOfEngagement: 'Engagement with Caution',
      emergencyProcedures: 'Quick Response Plan',
      communicationProtocols: 'Encrypted Messages',
      riskAssessment: 'Moderate Risk',
      contingencyPlans: 'Reinforcement Plan',
      permissionsClearances: 'Local Authority Permissions',
      ethicalGuidelines: 'Human Rights Compliance',
      debriefing: 'Post-Action Report',
      reporting: 'Mission Summary',
      evaluation: 'Effectiveness Review',
      emergencyContacts: 'Nearby Army Base',
      supportTeams: 'Medical Evacuation Team',
      documentation: 'Operation Files',
      environmentalConsiderations: 'High Humidity',
      status: 'completed' // Added status
    },
    {
      id: 3,
      missionName: 'Operation Shakti',
      objective: 'Disrupt smuggling operations',
      missionCode: 'SHAKTI123',
      location: 'Gujarat',
      date: '2024-03-20',
      time: '14:00',
      duration: '4 hours',
      teamMembers: 'Team Durg',
      commander: 'Major General Anil Verma',
      specialists: 'Lieutenant Colonel Rani Patel',
      vehicles: 'Land Rover Defender',
      weapons: 'SMG',
      communicationDevices: 'Walkie Talkies',
      medicalSupplies: 'Basic Medical Kit',
      specialEquipment: 'GPS Devices',
      transportArrangements: 'Ground Transport',
      accommodation: 'Local Inn',
      foodWaterSupply: 'Field Rations',
      threatAssessment: 'Low Risk',
      terrainAnalysis: 'Desert Terrain',
      surveillanceData: 'Local Intelligence Reports',
      rulesOfEngagement: 'Minimal Force',
      emergencyProcedures: 'Emergency Response Plan',
      communicationProtocols: 'Radio Communication',
      riskAssessment: 'Low Risk',
      contingencyPlans: 'Backup Operations',
      permissionsClearances: 'Local Customs Approvals',
      ethicalGuidelines: 'Operational Ethics',
      debriefing: 'End-of-Mission Briefing',
      reporting: 'Detailed Report',
      evaluation: 'Performance Assessment',
      emergencyContacts: 'Local Police',
      supportTeams: 'Support Squad Delta',
      documentation: 'Mission Reports',
      environmentalConsiderations: 'Dust and Heat',
      status: 'delayed' // Added status
    },
    {
      id: 4,
      missionName: 'Operation Trident',
      objective: 'Assist flood-affected regions',
      missionCode: 'TRIDENT123',
      location: 'Kerala',
      date: '2024-04-05',
      time: '16:00',
      duration: '5 hours',
      teamMembers: 'Team Varun',
      commander: 'Lieutenant Colonel Deepak Sharma',
      specialists: 'Captain Neelam Reddy',
      vehicles: 'Amphibious Vehicle',
      weapons: 'None',
      communicationDevices: 'Satellite Radio',
      medicalSupplies: 'Emergency Medical Kit',
      specialEquipment: 'Inflatable Boats',
      transportArrangements: 'Rescue Boats',
      accommodation: 'Temporary Shelters',
      foodWaterSupply: 'Relief Supplies',
      threatAssessment: 'High Risk of Waterborne Diseases',
      terrainAnalysis: 'Flooded Areas',
      surveillanceData: 'Weather Reports',
      rulesOfEngagement: 'Humanitarian Aid',
      emergencyProcedures: 'Disaster Response Plan',
      communicationProtocols: 'Secure Channels',
      riskAssessment: 'High Risk of Disease',
      contingencyPlans: 'Relief Operations',
      permissionsClearances: 'Disaster Management Permissions',
      ethicalGuidelines: 'Humanitarian Standards',
      debriefing: 'Aid Distribution Report',
      reporting: 'Daily Updates',
      evaluation: 'Relief Effectiveness',
      emergencyContacts: 'Local Disaster Control Room',
      supportTeams: 'Emergency Relief Team',
      documentation: 'Aid Records',
      environmentalConsiderations: 'Heavy Rainfall',
      status: 'failed' // Added status
    },
    {
      id: 5,
      missionName: 'Operation Shield',
      objective: 'Secure industrial area',
      missionCode: 'SHIELD123',
      location: 'Mumbai',
      date: '2024-05-10',
      time: '18:00',
      duration: '6 hours',
      teamMembers: 'Team Raksha',
      commander: 'Colonel Rajesh Patel',
      specialists: 'Major Sunita Menon',
      vehicles: 'SUV Patrols',
      weapons: 'Shotguns',
      communicationDevices: 'Encrypted Radios',
      medicalSupplies: 'First Aid Kits',
      specialEquipment: 'Security Cameras',
      transportArrangements: 'Patrol Vehicles',
      accommodation: 'Safe House',
      foodWaterSupply: 'Field Supplies',
      threatAssessment: 'Medium Risk',
      terrainAnalysis: 'Urban Terrain',
      surveillanceData: 'CCTV Footage',
      rulesOfEngagement: 'Protective Measures',
      emergencyProcedures: 'Incident Response Plan',
      communicationProtocols: 'Secure Communication',
      riskAssessment: 'Medium Risk of Theft',
      contingencyPlans: 'Security Reinforcement',
      permissionsClearances: 'Municipal Approvals',
      ethicalGuidelines: 'Security Ethics',
      debriefing: 'Security Report',
      reporting: 'Incident Reports',
      evaluation: 'Security Effectiveness',
      emergencyContacts: 'Local Security Office',
      supportTeams: 'Security Detail Bravo',
      documentation: 'Security Logs',
      environmentalConsiderations: 'Urban Infrastructure',
      status: 'hold' // Added status
    },
    {
      id: 6,
      missionName: 'Operation Phoenix',
      objective: 'Counter-terrorism operations',
      missionCode: 'PHOENIX123',
      location: 'Delhi',
      date: '2024-06-15',
      time: '20:00',
      duration: '7 hours',
      teamMembers: 'Team Agni',
      commander: 'General Arun Kumar',
      specialists: 'Colonel Priya Desai',
      vehicles: 'Bulletproof Vehicles',
      weapons: 'Assault Rifles',
      communicationDevices: 'Secure Satellite Phones',
      medicalSupplies: 'Advanced Trauma Kits',
      specialEquipment: 'Explosives Detection Gear',
      transportArrangements: 'Special Forces Transport',
      accommodation: 'Safe House',
      foodWaterSupply: 'Pre-packed Meals',
      threatAssessment: 'High Risk',
      terrainAnalysis: 'Urban Conflict Zones',
      surveillanceData: 'Intelligence Briefings',
      rulesOfEngagement: 'Engage with Force',
      emergencyProcedures: 'Rapid Response Plan',
      communicationProtocols: 'Encrypted Communication',
      riskAssessment: 'High Risk of Attack',
      contingencyPlans: 'Emergency Countermeasures',
      permissionsClearances: 'Counter-terrorism Authorizations',
      ethicalGuidelines: 'Operational Integrity',
      debriefing: 'Mission Debrief',
      reporting: 'Incident Summaries',
      evaluation: 'Operation Success',
      emergencyContacts: 'National Security Agency',
      supportTeams: 'Special Response Unit',
      documentation: 'Mission Records',
      environmentalConsiderations: 'Urban Warfare',
      status: 'cancelled' // Added status
    },
    {
        id: 7,
        missionName: 'Operation Red Dawn',
        objective: 'Capture high-value targets',
        missionCode: 'REDDAWN123',
        location: 'Kolkata',
        date: '2024-07-01',
        time: '22:00',
        duration: '5 hours',
        teamMembers: 'Team Sentinel',
        commander: 'Lieutenant Colonel Aarti Sharma',
        specialists: 'Captain Rahul Verma',
        vehicles: 'Armored Vehicles',
        weapons: 'M4 Carbine',
        communicationDevices: 'Encrypted Radios',
        medicalSupplies: 'Basic Medical Kit',
        specialEquipment: 'Thermal Vision',
        transportArrangements: 'Covert Transport',
        accommodation: 'Safe House',
        foodWaterSupply: 'Field Supplies',
        threatAssessment: 'High Risk',
        terrainAnalysis: 'Urban Areas',
        surveillanceData: 'Surveillance Cameras',
        rulesOfEngagement: 'Use Minimum Force',
        emergencyProcedures: 'Extraction Plan',
        communicationProtocols: 'Secure Lines',
        riskAssessment: 'High Risk of Confrontation',
        contingencyPlans: 'Backup Operation',
        permissionsClearances: 'Law Enforcement Approvals',
        ethicalGuidelines: 'Operational Conduct',
        debriefing: 'Mission Wrap-Up',
        reporting: 'Detailed Report',
        evaluation: 'Mission Effectiveness',
        emergencyContacts: 'Local SWAT Team',
        supportTeams: 'Rapid Response Unit',
        documentation: 'Operation Files',
        environmentalConsiderations: 'Crowded Urban Area',
        status: 'ongoing'
      },
      {
        id: 8,
        missionName: 'Operation Horizon',
        objective: 'Defend coastal region',
        missionCode: 'HORIZON123',
        location: 'Goa',
        date: '2024-07-15',
        time: '06:00',
        duration: '8 hours',
        teamMembers: 'Team Nautilus',
        commander: 'Major General Vikram Singh',
        specialists: 'Captain Meera Joshi',
        vehicles: 'Coast Guard Boats',
        weapons: 'Heavy Machine Guns',
        communicationDevices: 'Marine Radios',
        medicalSupplies: 'Emergency Medical Kits',
        specialEquipment: 'Radar Systems',
        transportArrangements: 'Marine Transport',
        accommodation: 'Coastal Base',
        foodWaterSupply: 'Local Supplies',
        threatAssessment: 'Medium Risk',
        terrainAnalysis: 'Coastal Terrain',
        surveillanceData: 'Radar Readings',
        rulesOfEngagement: 'Defensive Actions',
        emergencyProcedures: 'Evacuation Plan',
        communicationProtocols: 'Marine Communication',
        riskAssessment: 'Medium Risk of Attack',
        contingencyPlans: 'Reinforcement Request',
        permissionsClearances: 'Coastal Authority Permissions',
        ethicalGuidelines: 'Defense Protocols',
        debriefing: 'End-of-Day Briefing',
        reporting: 'Operational Summary',
        evaluation: 'Defensive Measures',
        emergencyContacts: 'Coast Guard HQ',
        supportTeams: 'Naval Support Unit',
        documentation: 'Mission Logs',
        environmentalConsiderations: 'Saltwater Corrosion',
        status: 'completed'
      },
      {
        id: 9,
        missionName: 'Operation Falcon',
        objective: 'Monitor airspace for intrusions',
        missionCode: 'FALCON123',
        location: 'Rajasthan',
        date: '2024-08-01',
        time: '04:00',
        duration: '6 hours',
        teamMembers: 'Team Eagle',
        commander: 'Wing Commander Rakesh Rao',
        specialists: 'Flight Lieutenant Ananya Roy',
        vehicles: 'Patrol Aircraft',
        weapons: 'None',
        communicationDevices: 'Aviation Radios',
        medicalSupplies: 'Basic First Aid',
        specialEquipment: 'Radar Systems',
        transportArrangements: 'Air Patrol',
        accommodation: 'Airbase Quarters',
        foodWaterSupply: 'In-Flight Supplies',
        threatAssessment: 'Low Risk',
        terrainAnalysis: 'Desert Airspace',
        surveillanceData: 'Air Traffic Data',
        rulesOfEngagement: 'Alert Procedures',
        emergencyProcedures: 'Aircraft Emergency Protocols',
        communicationProtocols: 'Aviation Communication',
        riskAssessment: 'Low Risk of Intrusion',
        contingencyPlans: 'Rapid Response Deployment',
        permissionsClearances: 'Aviation Authority Clearances',
        ethicalGuidelines: 'Flight Safety Standards',
        debriefing: 'Post-Flight Debrief',
        reporting: 'Airspace Reports',
        evaluation: 'Monitoring Effectiveness',
        emergencyContacts: 'Aviation Control Center',
        supportTeams: 'Air Support Unit',
        documentation: 'Flight Logs',
        environmentalConsiderations: 'Extreme Temperatures',
        status: 'delayed'
      },
      {
        id: 10,
        missionName: 'Operation Thunder',
        objective: 'Counter wildlife poaching',
        missionCode: 'THUNDER123',
        location: 'Kanha National Park',
        date: '2024-08-15',
        time: '18:00',
        duration: '7 hours',
        teamMembers: 'Team Forest Guard',
        commander: 'Colonel Arun Mehta',
        specialists: 'Major Sania Patel',
        vehicles: '4x4 Jeeps',
        weapons: 'Non-Lethal',
        communicationDevices: 'Walkie Talkies',
        medicalSupplies: 'First Aid Kits',
        specialEquipment: 'Night Vision Goggles',
        transportArrangements: 'Ground Patrol',
        accommodation: 'Field Camps',
        foodWaterSupply: 'Packaged Meals',
        threatAssessment: 'Medium Risk',
        terrainAnalysis: 'Forest Terrain',
        surveillanceData: 'Camera Traps',
        rulesOfEngagement: 'Non-Lethal Engagement',
        emergencyProcedures: 'Rapid Extraction Plan',
        communicationProtocols: 'Forest Communication Channels',
        riskAssessment: 'Medium Risk of Confrontation',
        contingencyPlans: 'Backup Patrol Units',
        permissionsClearances: 'Wildlife Authority Permissions',
        ethicalGuidelines: 'Anti-Poaching Standards',
        debriefing: 'Field Report',
        reporting: 'Poaching Incidents',
        evaluation: 'Operation Impact',
        emergencyContacts: 'Local Wildlife Authority',
        supportTeams: 'Conservation Support Team',
        documentation: 'Anti-Poaching Reports',
        environmentalConsiderations: 'Dense Forest',
        status: 'hold'
      },
      {
        id: 11,
        missionName: 'Operation Rescue',
        objective: 'Evacuate civilians from disaster zone',
        missionCode: 'RESCUE123',
        location: 'Uttarakhand',
        date: '2024-09-01',
        time: '12:00',
        duration: '8 hours',
        teamMembers: 'Team Lifesaver',
        commander: 'Major General Ravi Patel',
        specialists: 'Captain Neha Sharma',
        vehicles: 'Rescue Vehicles',
        weapons: 'None',
        communicationDevices: 'Satellite Phones',
        medicalSupplies: 'Emergency Medical Kits',
        specialEquipment: 'Rescue Tools',
        transportArrangements: 'Ground and Air Rescue',
        accommodation: 'Emergency Shelters',
        foodWaterSupply: 'Emergency Supplies',
        threatAssessment: 'High Risk of Natural Disasters',
        terrainAnalysis: 'Mountainous Region',
        surveillanceData: 'Disaster Area Reports',
        rulesOfEngagement: 'Humanitarian Aid',
        emergencyProcedures: 'Evacuation Plan',
        communicationProtocols: 'Disaster Response Channels',
        riskAssessment: 'High Risk of Further Disasters',
        contingencyPlans: 'Emergency Relief Operations',
        permissionsClearances: 'Disaster Management Permissions',
        ethicalGuidelines: 'Humanitarian Standards',
        debriefing: 'Evacuation Report',
        reporting: 'Crisis Updates',
        evaluation: 'Rescue Effectiveness',
        emergencyContacts: 'Disaster Control Room',
        supportTeams: 'Search and Rescue Teams',
        documentation: 'Rescue Logs',
        environmentalConsiderations: 'Rough Terrain',
        status: 'cancelled'
      },
      {
        id: 12,
        missionName: 'Operation Sentinel',
        objective: 'Protect critical infrastructure',
        missionCode: 'SENTINEL123',
        location: 'Hyderabad',
        date: '2024-09-15',
        time: '23:00',
        duration: '6 hours',
        teamMembers: 'Team Vigil',
        commander: 'Lieutenant Colonel Ankit Mehta',
        specialists: 'Major Sonali Reddy',
        vehicles: 'Patrol Vehicles',
        weapons: 'Rifles',
        communicationDevices: 'Secure Radios',
        medicalSupplies: 'First Aid Kits',
        specialEquipment: 'Surveillance Cameras',
        transportArrangements: 'Ground Patrol',
        accommodation: 'Secure Facility',
        foodWaterSupply: 'Field Supplies',
        threatAssessment: 'Medium Risk',
        terrainAnalysis: 'Urban Infrastructure',
        surveillanceData: 'Security Footage',
        rulesOfEngagement: 'Defensive Action',
        emergencyProcedures: 'Incident Response Plan',
        communicationProtocols: 'Secure Communication',
        riskAssessment: 'Medium Risk of Sabotage',
        contingencyPlans: 'Security Reinforcements',
        permissionsClearances: 'Infrastructure Security Approvals',
        ethicalGuidelines: 'Security Protocols',
        debriefing: 'Security Report',
        reporting: 'Operational Summary',
        evaluation: 'Protection Effectiveness',
        emergencyContacts: 'Security Operations Center',
        supportTeams: 'Security Detail',
        documentation: 'Security Logs',
        environmentalConsiderations: 'Urban Environment',
        status: 'ongoing'
      },
      {
        id: 13,
        missionName: 'Operation Shield',
        objective: 'Secure border area',
        missionCode: 'SHIELD123',
        location: 'Jammu & Kashmir',
        date: '2024-10-01',
        time: '05:00',
        duration: '10 hours',
        teamMembers: 'Team Border Guard',
        commander: 'Colonel Nitin Sharma',
        specialists: 'Major Arjun Yadav',
        vehicles: 'Border Patrol Jeeps',
        weapons: 'Assault Rifles',
        communicationDevices: 'Encrypted Radios',
        medicalSupplies: 'Emergency Medical Kits',
        specialEquipment: 'Infrared Scanners',
        transportArrangements: 'Ground and Air Patrol',
        accommodation: 'Field Bases',
        foodWaterSupply: 'Packaged Meals',
        threatAssessment: 'High Risk',
        terrainAnalysis: 'Rugged Border Terrain',
        surveillanceData: 'Border Surveillance',
        rulesOfEngagement: 'Defensive Measures',
        emergencyProcedures: 'Border Security Plan',
        communicationProtocols: 'Secure Lines',
        riskAssessment: 'High Risk of Intrusions',
        contingencyPlans: 'Reinforcements Available',
        permissionsClearances: 'Border Security Permissions',
        ethicalGuidelines: 'Engagement Protocols',
        debriefing: 'Border Security Briefing',
        reporting: 'Incident Reports',
        evaluation: 'Mission Effectiveness',
        emergencyContacts: 'Border Control HQ',
        supportTeams: 'Border Security Forces',
        documentation: 'Patrol Logs',
        environmentalConsiderations: 'Harsh Weather Conditions',
        status: 'completed'
      },
      {
        id: 14,
        missionName: 'Operation Vanguard',
        objective: 'Prevent smuggling activities',
        missionCode: 'VANGUARD123',
        location: 'Punjab',
        date: '2024-10-15',
        time: '09:00',
        duration: '7 hours',
        teamMembers: 'Team Frontier',
        commander: 'Lieutenant Colonel Meera Singh',
        specialists: 'Captain Kiran Rao',
        vehicles: 'Anti-Smuggling Vehicles',
        weapons: 'Non-Lethal',
        communicationDevices: 'Secure Radios',
        medicalSupplies: 'First Aid Kits',
        specialEquipment: 'X-Ray Scanners',
        transportArrangements: 'Ground Inspection',
        accommodation: 'Field Camps',
        foodWaterSupply: 'Emergency Rations',
        threatAssessment: 'Medium Risk',
        terrainAnalysis: 'Agricultural Terrain',
        surveillanceData: 'Inspection Reports',
        rulesOfEngagement: 'Non-Lethal Engagement',
        emergencyProcedures: 'Immediate Backup',
        communicationProtocols: 'Secure Channels',
        riskAssessment: 'Medium Risk of Smuggling',
        contingencyPlans: 'Additional Resources Available',
        permissionsClearances: 'Customs Approvals',
        ethicalGuidelines: 'Anti-Smuggling Protocols',
        debriefing: 'Operation Review',
        reporting: 'Smuggling Incidents',
        evaluation: 'Prevention Effectiveness',
        emergencyContacts: 'Customs Enforcement HQ',
        supportTeams: 'Anti-Smuggling Unit',
        documentation: 'Inspection Logs',
        environmentalConsiderations: 'Rural Terrain',
        status: 'hold'
      },
      {
        id: 15,
        missionName: 'Operation Phoenix',
        objective: 'Neutralize cyber threats',
        missionCode: 'PHOENIX123',
        location: 'Delhi',
        date: '2024-11-01',
        time: '14:00',
        duration: '5 hours',
        teamMembers: 'Team CyberGuard',
        commander: 'Major General Aryan Bhardwaj',
        specialists: 'Lieutenant Colonel Priya Mehta',
        vehicles: 'Cyber Operations Center',
        weapons: 'None',
        communicationDevices: 'Secure Communication Systems',
        medicalSupplies: 'None',
        specialEquipment: 'Cyber Defense Tools',
        transportArrangements: 'N/A',
        accommodation: 'Cyber Command Center',
        foodWaterSupply: 'Command Center Supplies',
        threatAssessment: 'High Risk',
        terrainAnalysis: 'Digital Infrastructure',
        surveillanceData: 'Cyber Threat Reports',
        rulesOfEngagement: 'Digital Defense',
        emergencyProcedures: 'Cyber Incident Response',
        communicationProtocols: 'Encrypted Channels',
        riskAssessment: 'High Risk of Cyber Attacks',
        contingencyPlans: 'Emergency Cyber Defense',
        permissionsClearances: 'Cyber Security Approvals',
        ethicalGuidelines: 'Cyber Security Standards',
        debriefing: 'Cyber Threat Analysis',
        reporting: 'Incident Reports',
        evaluation: 'Threat Neutralization',
        emergencyContacts: 'Cyber Security HQ',
        supportTeams: 'Cyber Security Task Force',
        documentation: 'Cyber Incident Logs',
        environmentalConsiderations: 'Digital Environment',
        status: 'delayed'
      },
      {
        id: 16,
        missionName: 'Operation Eagle Eye',
        objective: 'Surveillance of sensitive areas',
        missionCode: 'EAGLEEYE123',
        location: 'Bihar',
        date: '2024-11-15',
        time: '03:00',
        duration: '6 hours',
        teamMembers: 'Team Watchdog',
        commander: 'Lieutenant Colonel Ravi Kumar',
        specialists: 'Captain Ankit Patel',
        vehicles: 'Surveillance Vehicles',
        weapons: 'None',
        communicationDevices: 'High-Frequency Radios',
        medicalSupplies: 'Basic First Aid',
        specialEquipment: 'Long-Range Cameras',
        transportArrangements: 'Ground Surveillance',
        accommodation: 'Field Base',
        foodWaterSupply: 'Field Rations',
        threatAssessment: 'Low Risk',
        terrainAnalysis: 'Sensitive Areas',
        surveillanceData: 'Surveillance Footage',
        rulesOfEngagement: 'Observation Only',
        emergencyProcedures: 'Immediate Backup',
        communicationProtocols: 'Secure Lines',
        riskAssessment: 'Low Risk of Incidents',
        contingencyPlans: 'Rapid Response Available',
        permissionsClearances: 'Operational Permissions',
        ethicalGuidelines: 'Surveillance Protocols',
        debriefing: 'Surveillance Report',
        reporting: 'Surveillance Data',
        evaluation: 'Observation Effectiveness',
        emergencyContacts: 'Field Command Center',
        supportTeams: 'Surveillance Support Unit',
        documentation: 'Surveillance Logs',
        environmentalConsiderations: 'Low Light Conditions',
        status: 'cancelled'
      },
      {
        id: 17,
        missionName: 'Operation Atlas',
        objective: 'Conduct search and rescue operations',
        missionCode: 'ATLAS123',
        location: 'Himachal Pradesh',
        date: '2024-12-01',
        time: '08:00',
        duration: '8 hours',
        teamMembers: 'Team Rescue',
        commander: 'Major General Vikram Joshi',
        specialists: 'Captain Rhea Kapoor',
        vehicles: 'Search and Rescue Vehicles',
        weapons: 'None',
        communicationDevices: 'Satellite Phones',
        medicalSupplies: 'Advanced Medical Kits',
        specialEquipment: 'Rescue Equipment',
        transportArrangements: 'Ground and Air Transport',
        accommodation: 'Rescue Centers',
        foodWaterSupply: 'Emergency Supplies',
        threatAssessment: 'Medium Risk',
        terrainAnalysis: 'Mountainous Terrain',
        surveillanceData: 'Search Reports',
        rulesOfEngagement: 'Humanitarian Aid',
        emergencyProcedures: 'Emergency Response Plan',
        communicationProtocols: 'Emergency Channels',
        riskAssessment: 'Medium Risk of Difficult Terrain',
        contingencyPlans: 'Additional Rescue Teams',
        permissionsClearances: 'Search and Rescue Permissions',
        ethicalGuidelines: 'Rescue Protocols',
        debriefing: 'Rescue Report',
        reporting: 'Search and Rescue Updates',
        evaluation: 'Rescue Success',
        emergencyContacts: 'Rescue Coordination Center',
        supportTeams: 'Rescue Support Unit',
        documentation: 'Rescue Logs',
        environmentalConsiderations: 'Rough Terrain',
        status: 'completed'
      },
      {
        id: 18,
        missionName: 'Operation Stormbreaker',
        objective: 'Neutralize illegal arms trafficking',
        missionCode: 'STORMBREAKER123',
        location: 'Madhya Pradesh',
        date: '2024-12-15',
        time: '16:00',
        duration: '7 hours',
        teamMembers: 'Team Enforcer',
        commander: 'Colonel Rajesh Gupta',
        specialists: 'Major Priya Rao',
        vehicles: 'Anti-Trafficking Vehicles',
        weapons: 'Assault Rifles',
        communicationDevices: 'Secure Radios',
        medicalSupplies: 'Emergency Medical Kits',
        specialEquipment: 'Detection Tools',
        transportArrangements: 'Ground Inspection',
        accommodation: 'Field Camps',
        foodWaterSupply: 'Packaged Meals',
        threatAssessment: 'High Risk',
        terrainAnalysis: 'Mixed Terrain',
        surveillanceData: 'Trafficking Reports',
        rulesOfEngagement: 'Arrest and Confiscation',
        emergencyProcedures: 'Immediate Backup',
        communicationProtocols: 'Secure Channels',
        riskAssessment: 'High Risk of Armed Confrontation',
        contingencyPlans: 'Backup Units Available',
        permissionsClearances: 'Legal Permissions',
        ethicalGuidelines: 'Anti-Trafficking Standards',
        debriefing: 'Operation Debrief',
        reporting: 'Trafficking Incidents',
        evaluation: 'Operation Success',
        emergencyContacts: 'Anti-Trafficking HQ',
        supportTeams: 'Anti-Trafficking Unit',
        documentation: 'Trafficking Reports',
        environmentalConsiderations: 'Diverse Terrain',
        status: 'hold'
      },
      {
        id: 19,
        missionName: 'Operation Nightwatch',
        objective: 'Secure critical infrastructure',
        missionCode: 'NIGHTWATCH123',
        location: 'Mumbai',
        date: '2024-12-30',
        time: '22:00',
        duration: '9 hours',
        teamMembers: 'Team Sentinel',
        commander: 'Major General Anil Kapoor',
        specialists: 'Captain Seema Verma',
        vehicles: 'Security Vehicles',
        weapons: 'Non-Lethal',
        communicationDevices: 'Encrypted Radios',
        medicalSupplies: 'First Aid Kits',
        specialEquipment: 'Surveillance Systems',
        transportArrangements: 'Ground and Air Patrol',
        accommodation: 'Secure Facilities',
        foodWaterSupply: 'Emergency Rations',
        threatAssessment: 'Medium Risk',
        terrainAnalysis: 'Urban Infrastructure',
        surveillanceData: 'Infrastructure Reports',
        rulesOfEngagement: 'Non-Lethal Defense',
        emergencyProcedures: 'Immediate Response',
        communicationProtocols: 'Secure Channels',
        riskAssessment: 'Medium Risk of Security Breaches',
        contingencyPlans: 'Backup Teams Available',
        permissionsClearances: 'Security Approvals',
        ethicalGuidelines: 'Security Protocols',
        debriefing: 'Security Review',
        reporting: 'Security Incidents',
        evaluation: 'Mission Effectiveness',
        emergencyContacts: 'Security Command Center',
        supportTeams: 'Security Support Unit',
        documentation: 'Security Logs',
        environmentalConsiderations: 'High Density Area',
        status: 'completed'
      },
      {
        id: 20,
        missionName: 'Operation Ironclad',
        objective: 'Monitor and control border activities',
        missionCode: 'IRONCLAD123',
        location: 'Rajasthan',
        date: '2025-01-01',
        time: '06:00',
        duration: '8 hours',
        teamMembers: 'Team Frontier',
        commander: 'Lieutenant Colonel Rajeev Patel',
        specialists: 'Major Sunil Verma',
        vehicles: 'Border Monitoring Vehicles',
        weapons: 'Assault Rifles',
        communicationDevices: 'High-Frequency Radios',
        medicalSupplies: 'Advanced Medical Kits',
        specialEquipment: 'Surveillance Equipment',
        transportArrangements: 'Ground Patrol',
        accommodation: 'Field Bases',
        foodWaterSupply: 'Field Rations',
        threatAssessment: 'High Risk',
        terrainAnalysis: 'Desert Terrain',
        surveillanceData: 'Border Monitoring Reports',
        rulesOfEngagement: 'Monitoring and Control',
        emergencyProcedures: 'Rapid Response Plan',
        communicationProtocols: 'Secure Lines',
        riskAssessment: 'High Risk of Illegal Activities',
        contingencyPlans: 'Reinforcements Available',
        permissionsClearances: 'Border Security Permissions',
        ethicalGuidelines: 'Border Control Protocols',
        debriefing: 'Monitoring Report',
        reporting: 'Border Control Updates',
        evaluation: 'Monitoring Effectiveness',
        emergencyContacts: 'Border Control HQ',
        supportTeams: 'Border Security Forces',
        documentation: 'Monitoring Logs',
        environmentalConsiderations: 'Extreme Heat',
        status: 'hold'
      }
  ];
  